<template>
  <div class="login">
    <div class="login-bg">
      <!-- <a href="http://www.zhongpukeji.cn/#/home" class="logo_img">
        <img src="../../assets/img/layout/logo.png"
              alt="">
      </a> -->
      <div class="login-content">
        <!-- <h3>产业链供应链综合服务平台—客商门户</h3> -->
        <div style="margin-top: -60px;padding-bottom: 20px">
          <img src="../../assets/img/layout/logo.png"
              alt="">
        </div>
        <div class="form-content">
          <!-- 背景图片 -->
          <div class="bg-img">
            <img src="../../assets/img/layout/login_img.png"
                 style="height: 100%;" />
          </div>
          <!-- 登录框 -->
          <div class="form-box clearfix">
            <div v-if="loginType === 'form'">
              <h1>欢迎登录</h1>
              <el-form v-if="account"
                       :model="dataForm"
                       :rules="dataRule"
                       ref="dataForm"
                       @keyup.enter.native="dataFormSubmit()"
                       status-icon>
                <el-form-item prop="userName" style="background:#fff">
                  <el-input v-model="dataForm.userName"
                            class="account"
                            placeholder="请输入账号"></el-input>
                </el-form-item>
                <el-form-item prop="password" style="background:#fff">
                  <el-input v-model="dataForm.password"
                            type="password"
                            class="password"
                            placeholder="请输入密码"></el-input>
                </el-form-item>
                <!-- <el-form-item prop="chartCode">
                  <div class="captchaBox">
                    <el-input v-model="dataForm.chartCode"
                              type="chartCode"
                              class="chartCode"
                              placeholder="请输入验证码"></el-input>
                    <div id="chart"
                         style="width: 120px;height: 40px;margin-left: 10px"></div>
                  </div>

                </el-form-item> -->
              </el-form>
              <el-form v-else
                       :model="dataForm"
                       ref="dataForm"
                       :rules="dataRule"
                       status-icon>
                <el-form-item prop="phone" style="background:#fff">
                  <el-input v-model="dataForm.phone"
                            class="account"
                            placeholder="请输入手机号"></el-input>
                </el-form-item>
                <el-form-item prop="code" style="background:#fff">
                  <div class="captchaBox">
                    <el-input v-model="dataForm.code"
                              class="code"
                              placeholder="请输入验证码"></el-input>
                    <el-button size="mini"
                               @click="getCode"
                               :loading="laodCode"
                               :disabled="codeDisabled"
                               class="slotButton">
                      {{
                        codeDisabled ? "重新发送" + count + "S" : "发送验证码"
                      }}
                    </el-button>
                  </div>
                </el-form-item>
              </el-form>
              <div>
                <el-checkbox v-model="checked">记住我</el-checkbox>
                <i @click="checkword">{{
                  account ? "手机验证登录" : "账号密码登录"
                }}</i>
              </div>
              <el-button class="login-btn-submit"
                         type="primary"
                         :loading="loginState"
                         @click="dataFormSubmit()"
                         style="width:300px;height:45px;background:#00b541;border-radius:6px;border:0;font-size:16px;"
                         size="medium">登录</el-button>
              <div class="bottomBox">
                <span class="tip">还没有账号？<span class="register"
                        @click="$router.push({ name: 'register' })">去注册</span></span>
                <span class="register"
                      @click="$router.push({ name: 'retrieve' })">忘记密码?</span>
              </div>
            </div>
            <div v-else
                 class="QRCodeBox">
              <div>
                <div id="wx_qrcode"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog title="请选择租户"
               :visible.sync="dialog"
               width="30%"
               @close="cancelLogin">
      <div class="radio-box">
        <el-radio-group v-model="tenantId">
          <el-radio v-for="(item, i) in tenants"
                    :key="i"
                    :label="i">{{
            item.tenantName
          }}</el-radio>
        </el-radio-group>
      </div>
      <span slot="footer"
            class="dialog-footer">
        <el-button @click="dialog = false">取 消</el-button>
        <el-button type="primary"
                   :loading="setTenantState"
                   @click="setTenant">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
// import '../../assets/js/gVerify.js'
import { clearLoginInfo } from '@/utils'

export default {
  data () {
    let phoneReg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/
    let gangPhone = /^[0-9]{8}$/
    let validatePhone = (rule, value, callback) => {
      if (!phoneReg.test(value) && !gangPhone.test(value)) {
        callback(new Error('请输入手机号码'))
      } else {
        callback()
      }
    }
    // let validateChartCode = (rule, value, callback) => {
    //   if (!this.verifyCode.validate(this.dataForm.chartCode)) {
    //     callback(new Error('验证码输入有误'))
    //   } else {
    //     callback()
    //   }
    // }
    return {
      businessType: window.SITE_CONFIG['businessType'],
      laodCode: false,
      time: null,
      codeDisabled: false,
      count: null,
      account: true,
      loginType: 'form',
      setTenantState: false,
      dialog: false,
      tenant: '',
      tenantId: '',
      tenants: [],
      dataForm: {
        userName: '',
        password: '',
        captcha: '',
        phone: '',
        code: ''
      },
      form: {},
      dataRule: {
        userName: [
          { required: true, message: '帐号不能为空', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '密码不能为空', trigger: 'blur' }
        ],
        captcha: [
          { required: true, message: '验证码不能为空', trigger: 'blur' }
        ],
        phone: [
          { required: true, message: '手机号不能为空', trigger: 'blur' },
          { validator: validatePhone, trigger: ['blur', 'change'] }
        ],
        code: [{ required: true, message: '验证码不能为空', trigger: 'blur' }],
        chartCode: [
          { required: true, message: '请输入验证码', trigger: 'blur' },
          // { validator: validateChartCode, trigger: 'blur' }
        ]
      },
      captchaPath: '',
      checked: false,

      videoWidth: 400,
      videoHeight: 300,
      imgSrc: '',
      thisCancas: null,
      thisContext: null,
      thisVideo: null,
      validTip: '验证中',
      verifyCode: null,
      loginState: false
    }
  },
  computed: {
  },
  created () {
    if (this.getQueryVariable('result')) {
      let obj = JSON.parse(decodeURIComponent(this.getQueryVariable('result')))
      console.log(obj)
      this.loginSucess(obj)
    }
  },
  mounted () {
    this.getAccount()
  },
  beforeDestroy () {
  },
  methods: {
    cancelLogin () {
      clearLoginInfo()
      this.loginState = false
    },
    // 获取验证码
    getCode () {
      if (this.dataForm.phone) {
        this.laodCode = true
        this.$http({
          url: this.$http.adornUrl(
            window.SITE_CONFIG.contextPath +
            '/p/message/mobile/sendMobileCode?mobile=' +
            this.dataForm.phone
          ),
          method: 'get'
        })
          .then(({ data }) => {
            if (data && data.code === 'C0000') {
              this.$message.success('发送成功')
              this.codeDisabled = true
              const TIME_COUNT = 60
              this.count = TIME_COUNT
              this.time = setInterval(() => {
                if (this.count > 0 && this.count <= TIME_COUNT) {
                  this.count--
                } else {
                  this.codeDisabled = false
                  clearInterval(this.time)
                }
              }, 1000)
            } else {
              this.$message.error(data.message)
            }
          })
          .finally(() => {
            this.laodCode = false
          })
      } else {
        this.$message.error('请先输入手机号')
      }
    },
    // 登录
    dataFormSubmit () {
      if (this.account) {
        this.$refs.dataForm.validate(valid => {
          if (valid) {
            this.loginState = true
            this.$http({
              url: this.$http.adornUrl(
                window.SITE_CONFIG.contextPath + '/gateway/auth'
              ),
              method: 'post',
              data: {
                username: this.dataForm.userName,
                password: this.dataForm.password,
                loginType: 'pc'
              }
            })
              .then(({ data }) => {
                if (data && data.code === 'C0000') {
                  if (!data.result.token) {
                    this.loginState = false
                    this.$message.error('没有用户信息')
                    return
                  }
                  this.setAccount()
                  this.loginSucess(data.result)
                } else {
                  this.loginState = false
                  this.$message.error(data.message)
                  if (data.result && data.result.isAllowMessageLogin) {
                    this.account = false
                  }
                }
              })
              .catch(() => {
                this.loginState = false
              })
          }
        })
      } else {
        this.$refs.dataForm.validate(valid => {
          if (valid) {
            this.loginState = true
            this.$http({
              url: this.$http.adornUrl(
                window.SITE_CONFIG.contextPath + '/p/user/phoneLogin'
              ),
              method: 'post',
              data: {
                mobile: this.dataForm.phone,
                captcha: this.dataForm.code
              }
            })
              .then(({ data }) => {
                if (data && data.code === 'C0000') {
                  if (!data.result.token) {
                    this.loginState = false
                    this.$message.error('当前用户没有注册')
                    return
                  }
                  this.setAccount()
                  this.loginSucess(data.result)
                } else {
                  this.loginState = false
                  this.$message.error(data.message)
                  if (data.result && data.result.isAllowPasswordLogin) {
                    this.account = true
                  }
                }
              })
              .catch(() => {
                this.loginState = false
              })
          }
        })
      }
    },
    getQueryVariable (variable) {
      var query = window.location.hash.substring(8)
      var vars = query.split('&')
      for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split('=')
        if (pair[0] === variable) {
          return pair[1]
        }
      }
      return false
    },
    checkword () {
      this.account = !this.account
      this.$refs['dataForm'].resetFields()
    },
    getAccount () {
      var curTime = new Date().getTime()
      var data = localStorage.getItem('information')
      var dataObj = JSON.parse(data)
      if (data) {
        if (curTime - dataObj.time > 1000 * 60 * 60 * 24 * 7) {
          localStorage.removeItem('information')
        } else {
          this.dataForm.userName = dataObj.data.userName
          this.dataForm.password = dataObj.data.password
          this.checked = true
        }
      }
    },
    setAccount () {
      if (this.checked) {
        var curTime = new Date().getTime()
        localStorage.setItem(
          'information',
          JSON.stringify({ data: this.dataForm, time: curTime })
        )
      }
    },
    setTenant () {
      this.setTenantState = true
      this.$http({
        url: this.$http.adornUrl(
          window.SITE_CONFIG.contextPath + '/p/tenant/checkTenant'
        ),
        method: 'post',
        data: {
          id: this.tenants[this.tenantId].tenantId
        }
      })
        .then(res => {
          this.setTenantState = false
          this.$cookie.set('isOuter', this.tenants[this.tenantId].isOuter)
          this.ActionsAvatarUrl(this.tenants[this.tenantId].avatarUrl)
          this.$cookie.set('orgId', this.tenants[this.tenantId].organizationId)
          this.ActionsUserId(this.tenants[this.tenantId].id)
          this.ActionsTenantId(this.tenants[this.tenantId].tenantId)
          this.$router.replace({ path: '/home' })
          this.loginState = false
        })
        .catch(() => {
          this.loginState = false
        })
    },
    loginSucess (data) {
      this.$cookie.set('token', data.token)
      this.$store.commit('user/updateIsLogin', true)
      this.$cookie.set('username', this.dataForm.userName)
      this.$cookie.set('mobile', data.loginAuthDto.mobile)
      let accountId = data.loginAuthDto.accountId
      this.ActionsAccountId(accountId)
      this.ActionsRealName(data.loginAuthDto.realName)
      if (data.loginAuthDto.isAdmin) {
        this.$router.replace({ path: '/home' })
      } else {
        this.$http({
          url: this.$http.adornUrl(
            window.SITE_CONFIG.contextPath + '/p/user/getUsersByAccountId'
          ),
          method: 'post',
          data: {
            id: accountId
          }
        }).then(res => {
          if (res.data && res.data.code === 'C0000') {
            if (!res.data.result.length) {
              this.loginState = false
              this.$message.error('当前用户没有租户信息')
            } else if (res.data.result.length === 1) {
              this.tenantId = 0
              this.tenants = res.data.result
              this.setTenant()
            } else {
              this.dialog = true
              this.tenantId = 0
              this.tenants = res.data.result
            }
          } else {
            this.loginState = false
            this.$message.error(res.data.message)
          }
        })
      }
    },
    /*
     *@author wf_Huang
     *@Time 2019/6/5 0005 17:35
     *@function  调用权限
     *****************************************/
    getCompetence () {
      var _this = this
      this.thisCancas = document.getElementById('canvasCamera')
      this.thisContext = this.thisCancas.getContext('2d')
      this.thisVideo = document.getElementById('videoCamera')
      // 旧版本浏览器可能根本不支持mediaDevices，我们首先设置一个空对象
      if (navigator.mediaDevices === undefined) {
        navigator.mediaDevices = {}
      }
      // 一些浏览器实现了部分mediaDevices，我们不能只分配一个对象
      // 使用getUserMedia，因为它会覆盖现有的属性。
      // 这里，如果缺少getUserMedia属性，就添加它。
      if (navigator.mediaDevices.getUserMedia === undefined) {
        navigator.mediaDevices.getUserMedia = function (constraints) {
          // 首先获取现存的getUserMedia(如果存在)
          var getUserMedia =
            navigator.webkitGetUserMedia ||
            navigator.mozGetUserMedia ||
            navigator.getUserMedia
          // 有些浏览器不支持，会返回错误信息
          // 保持接口一致
          if (!getUserMedia) {
            return Promise.reject(
              new Error('getUserMedia is not implemented in this browser')
            )
          }
          // 否则，使用Promise将调用包装到旧的navigator.getUserMedia
          return new Promise(function (resolve, reject) {
            getUserMedia.call(navigator, constraints, resolve, reject)
          })
        }
      }
      var constraints = {
        audio: false,
        video: {
          width: this.videoWidth,
          height: this.videoHeight,
          transform: 'scaleX(-1)'
        }
      }
      navigator.mediaDevices
        .getUserMedia(constraints)
        .then(function (stream) {
          // 旧的浏览器可能没有srcObject
          if ('srcObject' in _this.thisVideo) {
            _this.thisVideo.srcObject = stream
          } else {
            // 避免在新的浏览器中使用它，因为它正在被弃用。
            _this.thisVideo.src = window.URL.createObjectURL(stream)
          }
          _this.thisVideo.onloadedmetadata = function (e) {
            _this.thisVideo.play()
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    /*
     *@author wf_Huang
     *@Time 2019/6/5 0005 17:32
     *@function  绘制图片
     *****************************************/
    setImage () {
      var _this = this
      // 点击，canvas画图
      _this.thisContext.drawImage(
        _this.thisVideo,
        0,
        0,
        _this.videoWidth,
        _this.videoHeight
      )
      // 获取图片base64链接
      var image = this.thisCancas.toDataURL('image/png')
      _this.imgSrc = image
      this.$emit('refreshDataList', this.imgSrc)
    },
    /*
     *@author wf_Huang
     *@Time 2019/6/5 0005 17:44
     *@function  base64转文件
     *****************************************/
    dataURLtoFile (dataurl, filename) {
      var arr = dataurl.split(',')
      var mime = arr[0].match(/:(.*?);/)[1]
      var bstr = atob(arr[1])
      var n = bstr.length
      var u8arr = new Uint8Array(n)
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }
      return new File([u8arr], filename, { type: mime })
    },
    /*
     *@author wf_Huang
     *@Time 2019/6/10 0010 3:41
     *@function  关闭摄像头
     *****************************************/
    stopNavigator () {
      this.thisVideo.srcObject.getTracks()[0].stop()
    },
    ...mapActions('user', ['ActionsAccountId', 'ActionsUserId', 'ActionsTenantId', 'ActionsRealName', 'ActionsAvatarUrl'])
  }
}
</script>

<style lang="scss">
.trial-btn {
  display: inline-block;
  width: 120px;
  height: 32px;
  // background: #fff;
  border: 1px solid #fff;
  line-height: 30px;
  border-radius: 4px;
  color: #fff;
  font-weight: bold;
  cursor: pointer;
}
.captchaBox {
  display: flex;
  justify-content: space-between;
  .slotButton {
    width: 135px;
    margin: 0 0 0 1px;
    background: #fff;
    border: 1px solid #fff;
    color: #00b541;
    font-size: 12px;
    display: flex;
    line-height: 28px;
    justify-content: center;
    border-bottom: 1px solid #eee;
    border-radius: 0;
  }
  .slotButton:hover {
    background: #00b541 !important;
    color: #fff;
  }
}
.clearfix:before,
.clearfix:after {
  content: "";
  display: block;
  clear: both;
  height: 0;
  line-height: 0;
}
.clearfix {
  zoom: 1;
}
html,
body {
  height: 100%;
  width: 100%;
  min-width: 1200px;
  min-height: 700px;
}
.login {
  display: table;
  width: 100%;
  height: 100%;
  _position: relative;
  .login-bg {
    vertical-align: middle;
    display: flex;
    text-align: center;
    /*background: url("../../assets/img/login/login_bg.jpg") center;
    background-size: cover;
    background-repeat: no-repeat;*/
    background: #77bcd1;
    overflow: auto;
    justify-content: center;
    align-items: center;
    height: 100%;
    position: relative;
  }
  .login-content {
    width: 1152px;
    .el-checkbox__input.is-checked .el-checkbox__inner {
      background-color: #00b541;
      border-color: #00b541;
    }
    .el-checkbox__input.is-checked+.el-checkbox__label {
      color: #00b541;
    }
    h3 {
      font-size: 50px;
      color: #fff;
      font-family: 'alimamashuheiti';
      text-align: center;
      margin: -108px auto 50px;
    }
    .form-content {
      position: relative;
      width: 100%;
      height: 400px;
      border-radius: 9px;
      overflow: hidden;
      background: #c2e2ec;
      // background: linear-gradient(
      //   90deg,
      //   rgba(20, 142, 235, 1) 0%,
      //   rgba(255, 255, 255, 1) 60%
      // );
      img.QRCode {
        position: absolute;
        right: 3px;
        top: 3px;
        cursor: pointer;
      }
      .bg-img {
        width: 66%;
        height: 100%;
        float: left;
        // background: linear-gradient(-75deg, #0077f1, #00f6ff);
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        // margin-right: 1px;
        // border-radius: 9px;
        overflow: hidden;
        .manager {
          position: relative;
          width: 100%;
          height: 100%;
          // border-radius: 9px;
        }
      }
      .form-box {
        width: 34%;
        height: 100%;
        float: right;
        // border-radius: 9px;
        .el-checkbox {
          color: #333;
        }
        h1 {
          font-size: 24px;
          font-family: Microsoft YaHei;
          font-weight: bold;
          line-height: 50px;
          margin: 25px auto 15px;
          color: #333;
        }
        form {
          display: block;
          width: 300px;
          margin: auto;
          .account {
            background: url("../../assets/img/layout/icon_1.png");
            background-size: 26px 26px;
            background-position: 8px 8px;
            background-repeat: no-repeat;
            padding-left: 36px;
            height: 42px;
            box-sizing: border-box;
          }
          .password {
            background: url("../../assets/img/layout/icon_2.png");
            background-size: 26px 26px;
            background-position: 8px 8px;
            background-repeat: no-repeat;
            padding-left: 36px;
            height: 42px;
            box-sizing: border-box;
          }
          .code {
            background: url("../../assets/img/layout/icon_3.png");
            background-size: 26px 26px;
            background-position: 8px 8px;
            background-repeat: no-repeat;
            padding-left: 36px;
            height: 42px;
            box-sizing: border-box;
          }
        }
        form + div {
          width: 300px;
          text-align: left;
          margin: 0 auto 28px;
          i {
            float: right;
            color: #333;
            font-style: normal;
            font-size: 12px;
            cursor: pointer;
          }
        }
      }
    }
  }
  .bottomBox {
    display: flex;
    margin: 18px 48px 0 48px;
    justify-content: space-between;
  }
  .register {
    text-align: center;
    color: #333;
    cursor: pointer;
    font-size: 12px;
  }
  .register:hover {
    color: #00b541;
  }
  .QRCodeBox {
    width: 100% !important;
    height: 100% !important;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .is-success {
    border-bottom: 1px #67c23a solid !important;
    background: white !important;
  }
  .is-error {
    border-bottom: 1px #f56c6c solid !important;
    background: white !important;
  }
  .el-input {
    border-bottom: 1px #eeeeee solid !important;
  }
  .el-input__inner {
    border: none;
    border-radius: 0 !important;
  }
}
.radio-box {
  .el-radio {
    display: block;
    line-height: 40px;
  }
  .el-radio + .el-radio {
    margin-left: 10px;
  }
}

.logo_code {
  position: absolute;
  margin: 20px auto;
  display: flex;
  width: 1152px;
  justify-content: center;
  .code {
    width: 200px;
    height: 200px;
    background: #fff;
    padding: 20px 10px;
    img {
      width: 80%;
    }
    p {
      font-size: 12px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #ffffff;
    }
  }
  .companyName {
    color: #fff;
    margin: 60px 10px;
    font-size: 24px;
    font-weight: bold;
    font-family: "Courier New", Courier, monospace;
    p {
      margin: 6px 0;
    }
  }
}
#wx_qrcode {
  position: relative;
  height: 100%;
  img {
    margin-top: 70px;
    padding: 14px;
    border: 1px solid #eee;
  }
  h2 {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    height: 25px;
    font-size: 24px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #333333;
    line-height: 50px;
  }
  p {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #333333;
    line-height: 50px;
  }
}
.login .login-content {
  position: relative;
}
.logo_img {
  position: absolute;
  width: 200px;
  left: 20px;
  top: 20px;
  img {
    width: 100%;
  }
}
.impowerBox .title,
.impowerBox .status p {
  color: #333 !important;
}
.impowerBox .loginPanel { color: #333 }
// .impowerBox .loginPanel {margin-top: 50px;color: #fff}
// .impowerBox .qrcode {width: 200px;}
// .impowerBox .info {width: 200px;}
// .status_icon {display: none}
// .js_wx_after_scan {width: 400px;}
// js_wx_after_cancel {width: 400px;}
// .js_wx_default_tip p:last-child {display:none}
// .web_qrcode_switch{color: #0ba5ff}
// .qlogin_mod{margin-top: 80px}
</style>



// WEBPACK FOOTER //
// src/views/common/login.vue